/** @type {Record<string, { title: string, description: string, locale: string }>} */
export const SEO_BY_LOCALE = {
  en: {
    title: 'AquaMind | AI Mascots for Business Growth',
    description: 'AquaMind helps brands build, deploy, and productize AI mascots with 3D physical presence, multilingual experiences, and real business impact.',
    locale: 'en_US',
  },
  'zh-CN': {
    title: 'AquaMind | 以 AI 吉祥物重塑品牌业务',
    description: 'AquaMind 帮助品牌打造、部署并产品化 AI 吉祥物，结合 3D 实体形态、多语言体验与可落地的商业价值。',
    locale: 'zh_CN',
  },
  'zh-TW': {
    title: 'AquaMind | 以 AI 吉祥物重塑品牌業務',
    description: 'AquaMind 協助品牌打造、部署並產品化 AI 吉祥物，結合 3D 實體形態、多語言體驗與可落地的商業價值。',
    locale: 'zh_TW',
  },
  ja: {
    title: 'AquaMind | AIマスコットでブランド成長を加速',
    description: 'AquaMind は、3D実体表現と多言語体験を備えた AI マスコットの構築・展開・事業化を支援します。',
    locale: 'ja_JP',
  },
  ko: {
    title: 'AquaMind | AI 마스코트로 비즈니스 성장을 설계',
    description: 'AquaMind는 3D 물리적 존재감과 다국어 경험을 갖춘 AI 마스코트를 구축, 배포, 제품화할 수 있도록 지원합니다.',
    locale: 'ko_KR',
  },
  es: {
    title: 'AquaMind | Mascotas de IA para impulsar tu negocio',
    description: 'AquaMind ayuda a las marcas a crear, desplegar y convertir en producto mascotas de IA con presencia física 3D y experiencias multilingues.',
    locale: 'es_ES',
  },
  fr: {
    title: 'AquaMind | Des mascottes IA pour transformer votre activite',
    description: 'AquaMind aide les marques a creer, deployer et industrialiser des mascottes IA avec presence physique 3D et experiences multilingues.',
    locale: 'fr_FR',
  },
  de: {
    title: 'AquaMind | KI-Maskottchen fuer messbares Wachstum',
    description: 'AquaMind hilft Marken dabei, KI-Maskottchen mit 3D-Praesenz, mehrsprachigen Erlebnissen und echtem Geschaeftswert zu entwickeln und auszurollen.',
    locale: 'de_DE',
  },
};
